export { default } from './ItemResultatGeneral';
